import { useState } from "react";
import { toast } from "sonner";
import { Lock, SignIn } from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";

/** Developer login page — shown when there is no valid session token. */
export default function Login() {
  const { devLogin, error: authError } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await devLogin(username.trim(), password);
      toast.success("Prihlásený");
    } catch (e2) {
      const msg = e2.response?.data?.detail || e2.message || "Prihlásenie zlyhalo";
      setErr(msg);
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-app)] px-4">
      <div className="w-full max-w-sm bg-white rounded-lg border border-[var(--border-default)] shadow-sm p-8">
        <div className="flex flex-col items-center text-center gap-2 mb-6">
          <div className="w-12 h-12 rounded-full bg-[var(--brand)]/10 text-[var(--brand)] flex items-center justify-center">
            <Lock size={22} weight="duotone" />
          </div>
          <h1 className="font-display text-lg font-bold tracking-tight">Prihlásenie</h1>
          <p className="text-xs text-[var(--text-muted)]">Hodinový výkon &amp; Vyťaženosť · vývojárske konto</p>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <label className="block">
            <span className="text-xs font-semibold text-[var(--text-secondary)]">Používateľské meno</span>
            <input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="mt-1 w-full px-3 py-2 rounded border border-[var(--border-default)] focus:outline-none focus:border-[var(--brand)] text-sm"
              data-testid="login-username-input"
            />
          </label>
          <label className="block">
            <span className="text-xs font-semibold text-[var(--text-secondary)]">Heslo</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full px-3 py-2 rounded border border-[var(--border-default)] focus:outline-none focus:border-[var(--brand)] text-sm"
              data-testid="login-password-input"
            />
          </label>

          {(err || authError) && (
            <div className="text-xs text-[var(--critical)] bg-[var(--critical-bg)] rounded px-3 py-2" data-testid="login-error">
              {err || authError}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            className="w-full bg-[var(--brand)] text-white py-2 rounded font-semibold text-sm hover:bg-[var(--brand-hover)] disabled:opacity-60 inline-flex items-center justify-center gap-2"
            data-testid="login-submit-btn"
          >
            <SignIn size={16} /> {busy ? "Prihlasujem…" : "Prihlásiť sa"}
          </button>
        </form>

        <p className="mt-6 text-[10px] text-center text-[var(--text-muted)] leading-relaxed">
          Ak ste klient TiDo, otvorte aplikáciu z prostredia TiDo — prihlási vás automaticky.
        </p>
      </div>
    </div>
  );
}
